<div [ngClass]="fundId === '0517' ? 'hidden' : 'pagination-container'">
  <div class="dropdown-container" #selectElement>
    <vmf-pagination [paginationLabel]="currentType" class="select-value" (newPageNumber)="changePage($event)"  [listSize]="listSize"></vmf-pagination>
  </div>
</div>
